<template>
  <el-tabs v-model="activeName">
      <el-tab-pane v-if="judgePermission('workbench_ent_rent_order_main')" :label="'企业租赁订单（'+primaryTotal+'）'" name="primary">
        <div v-if="activeName === 'primary'">
          <primaryOrder />
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="judgePermission('workbench_ent_rent_order_sub')" :label="'企业租赁子订单（'+childTotal+'）'" name="child">
        <div v-if="activeName === 'child'">
          <childOrder :queryAllActiveName="queryAllActiveName" :carId="carId" :plateNo="plateNo" />
        </div>
      </el-tab-pane>
    </el-tabs>
</template>
<script>
import primaryOrder from '../components/primaryOrder.vue'
import childOrder from '../components/childOrder.vue'
// eslint-disable-next-line import/no-cycle
import { getLeaseOrderSummary } from '@/api/purchaseAndSaleAPI'
import { parseQueryJsonStr } from '@/utils/querySchema'

export default {
  components: {
    primaryOrder,
    childOrder,
  },
  data() {
    return {
      activeName: 'primary',
      primaryTotal: 0,
      childTotal: 0,
      queryAllActiveName: '', // 子订单二级tab
      carId: '',
      plateNo: '',
    }
  },

  mounted() {
    this.getTabsList()
  },
  created() {
    // activeName：primary-选中主订单；child-选中子订单；  workbench_ent_rent_order_main：主订单权限；workbench_ent_rent_order_sub：子订单权限
    // eslint-disable-next-line no-nested-ternary
    this.activeName = this.judgePermission('workbench_ent_rent_order_main') ? 'primary' : this.judgePermission('workbench_ent_rent_order_sub') ? 'child' : 'primary'
    this.getRouteQuery()
  },
  methods: {
    getRouteQuery() {
      const { listType = '', activeName, carId, plateNo } = this.$route.query
      if (listType === 'child') {
        this.activeName = listType
      }
      if (activeName) {
        this.activeName = activeName
      }
      // 数据报表跳转
      const queryStr = this.$route.query.query
      if (queryStr) {
        const queryObj = parseQueryJsonStr(queryStr)
        const { tab, search, children } = queryObj
        if (tab) this.activeName = tab

        if (children && children.length) {
          this.queryAllActiveName = children[0].tab
        }
      }
      this.carId = carId
      this.plateNo = plateNo
    },
    // tab数据----请求数据
    async getTabsList() {
      try {
        const { code, data } = await getLeaseOrderSummary({})
        if (code === 1) {
          this.primaryTotal = data.allOrderNum || 0
          this.childTotal = data.subOrderNum || 0
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

